<app-page-title [title]="'common.navigation.settings.title' | translateSafe"
                iconName="settings" />

<div class="settings-content">
  <app-settings-navigation />

  <router-outlet />
</div>
